/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Mantine
import {
	Box,
	LoadingOverlay,
	Text,
	Tooltip,
} from '@mantine/core';

// Styles
import classes from './Measurabilities.module.css';

// I18n
import { useTranslation } from 'react-i18next';

// Constants
import { NOT_APPLICABLE } from '@config/constants/common';

// Utils

// Apis
import { useOffsetById } from '@features/offsets/api/get-offset-by-id';

// Lodash
import isNil from 'lodash/isNil';

// Types
import { ROLES } from '@config/constants/roles';
import { TParsedRowProject } from '@features/offsets/types';
import { useAuthorization } from '@lib/authorization';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type RowExpansionProps = {
	offsetId: string;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

export const Measurabilities = (
	props: RowExpansionProps
) => {
	/* ******************************** Hooks ******************************* */
	const { t } = useTranslation();

	const { measurabilities, isLoading } = useOffsetById(
		props.offsetId
	);

	const { checkRole } = useAuthorization();

	const rowsMesurability =
		Array.isArray(measurabilities) &&
		measurabilities.length > 0 ? (
			measurabilities.map((item: TParsedRowProject) => (
				<Box key={item.id} className={classes.row}>
					<Tooltip
						disabled={
							(!isNil(item) && isNil(item.name)) ||
							(!isNil(item.name) &&
								item.name.length <= 30)
						}
						label={item.name}
					>
						<Box className={classes.divition}>
							<Text className={classes.rowText}>
								{item.name}
							</Text>
						</Box>
					</Tooltip>
					{!checkRole([ROLES.STAFF]) && (
						<Box className={classes.divition}>
							<Text className={classes.rowText}>
								{item.price}
							</Text>
						</Box>
					)}
					<Box className={classes.divition}>
						<Text className={classes.rowText}>
							{item.quantity}
						</Text>
					</Box>
					{!checkRole([ROLES.STAFF]) && (
						<Box className={classes.divition}>
							<Text className={classes.rowText}>
								{item.total}
							</Text>
						</Box>
					)}
				</Box>
			))
		) : (
			<Box className={classes.row}>
				<Box className={classes.divition}>
					<Text className={classes.rowText}>
						{NOT_APPLICABLE}
					</Text>
				</Box>
				{!checkRole([ROLES.STAFF]) && (
					<Box className={classes.divition}>
						<Text className={classes.rowText}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
				)}
				<Box className={classes.divition}>
					<Text className={classes.rowText}>
						{NOT_APPLICABLE}
					</Text>
				</Box>
				{!checkRole([ROLES.STAFF]) && (
					<Box className={classes.divition}>
						<Text className={classes.rowText}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
				)}
			</Box>
		);

	/* ******************************** RENDERING ******************************* */
	return (
		<>
			{isLoading ? (
				<Box
					pos="relative"
					className={classes.containerOverlay}
				>
					<LoadingOverlay
						visible={true}
						zIndex={1000}
						overlayProps={{ radius: 'sm', blur: 2 }}
					/>
				</Box>
			) : (
				<Box className={classes.container}>
					<Box className={classes.header}>
						<Box className={classes.divition}>
							<Text className={classes.headerText}>
								{t('global.project')}
							</Text>
						</Box>
						{!checkRole([ROLES.STAFF]) && (
							<Box className={classes.divition}>
								<Text className={classes.headerText}>
									{t('global.pricePerTco2e')}
								</Text>
							</Box>
						)}
						<Box className={classes.divition}>
							<Text className={classes.headerText}>
								{t('global.quantity')}
							</Text>
						</Box>
						{!checkRole([ROLES.STAFF]) && (
							<Box className={classes.divition}>
								<Text className={classes.headerText}>
									{t('global.totalPricePerProject')}
								</Text>
							</Box>
						)}
					</Box>

					<Box className={classes.row}>
						{/*Mesurability projects rows */}
						<Box className={classes.rowsDivision}>
							{rowsMesurability}
						</Box>
					</Box>
				</Box>
			)}
		</>
	);
};
